export default __webpack_public_path__ + "static/media/Slider-4.49f76e1b.jpg";